import { ref } from "vue";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
export function useShareModal() {
  var shareModalData = ref(null);
  var gaEvent = ref(null);
  var openShareModal = (data, location, _gaEvent) => {
    if (!navigator.share || !(window.screen.width < BREAKPOINT.LARGE)) {
      shareModalData.value = data;
      shareModalData.value.location = location;
      if (_gaEvent) gaEvent.value = _gaEvent;
      return;
    }
    shareModalData.value = null;
    gaEvent.value = undefined;
    navigator.share({
      url: data.url || "",
      title: data.title || ""
    }).then(() => {
      //We want to send the GAEvent iff the user presses a share button!
      //If the native modal is closed, a DOMException will be thrown
      if (_gaEvent) sendGAEvent(_gaEvent, {
        event_location: "".concat(location, " - Modale Nativo Condivisione Mobile"),
        social: null
      });
    });
  };
  return {
    gaEvent,
    shareModalData,
    openShareModal
  };
}